import React from 'react';
import RootCommentBox from '../comment-box/root-comment-box';
import { useApi } from '../../context/api-context/use-api';
import { getIsMobile, getIsSSR } from '../../../common/store/base-params/base-params-selectors';
import { resolveSomeoneIsTyping } from './resolve-someone-is-typing';
import CommentingLockedEmptyState from '../../empty-states/commenting-locked-empty-state';
import { unreachable } from '../../../ts-utils';
import { DummyCommentBox } from '../comment-box';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { st, classes } from './end-root-box-section.st.css';
import { usePermissions } from '../../context/permissions-context/use-permissions';
const EndRootBoxSectionNoMemo = ({ someoneIsTyping, boxRating }) => {
    const { resourceId } = useConfiguration();
    const { getPermission } = usePermissions();
    const { someoneIsTypingDev, isSSR, isMobile, loginRequiredDev, biAttemptLoginSignup, requestLoginAction, } = useApi((state, actions, _, ctx) => ({
        loginRequiredDev: ctx.wcDevToolsState.specialStates === 'login_required',
        someoneIsTypingDev: ctx.wcDevToolsState.showSomeoneIsTyping,
        isSSR: getIsSSR(state),
        isMobile: getIsMobile(state),
        biAttemptLoginSignup: actions.biAttemptLoginSignup,
        requestLoginAction: actions.requestLogin,
    }));
    const requestLogin = () => {
        biAttemptLoginSignup({ type: 'login', resourceId });
        requestLoginAction({ mode: 'login' });
    };
    const addCommentPermission = getPermission({ action: 'CREATE_COMMENT' });
    return (React.createElement("div", { className: st(classes.root, { isMobile }) }, (() => {
        if (loginRequiredDev) {
            return React.createElement(DummyCommentBox, { className: classes.commentBox, onClick: requestLogin });
        }
        if (addCommentPermission.type === 'ALLOW') {
            return (React.createElement(React.Fragment, null,
                !isSSR && resolveSomeoneIsTyping('end', someoneIsTypingDev, someoneIsTyping),
                React.createElement(RootCommentBox, { className: classes.commentBox, position: "end", shoudDispatchIAmTyping: addCommentPermission.precondition === 'NONE' ||
                        addCommentPermission.precondition === 'GUEST_FLOW', withGuestFlow: addCommentPermission.precondition === 'GUEST_FLOW', canRate: getPermission({ action: 'RATE' }).type === 'ALLOW', boxRating: boxRating })));
        }
        switch (addCommentPermission.reason) {
            case 'LOCKED':
                return (React.createElement("div", { className: classes.lockedState },
                    React.createElement(CommentingLockedEmptyState, null)));
            case 'LOGIN_REQUIRED':
                return React.createElement(DummyCommentBox, { className: classes.commentBox, onClick: requestLogin });
            case 'UNKNOWN':
                return null;
            default:
                throw unreachable(addCommentPermission.reason);
        }
    })()));
};
const EndRootBoxSection = React.memo(EndRootBoxSectionNoMemo);
export default EndRootBoxSection;
//# sourceMappingURL=end-root-box-section.js.map